import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // KRITIEK: bij terugkeer van Google OAuth slaat AuthCallback de sessie-uitwisseling over;
    // AuthCallback wisselt eerst de session_id in voordat /auth/me wordt aangeroepen.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("stoof_token", data.token);
    setUser(data);
    return data;
  };

  const googleCallback = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("stoof_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, googleCallback }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
